class CardSlider extends HTMLElement {
  constructor() {
    super();
    this.scroller = this.querySelector('.card-slider__scroller');
    this.btnPrev = this.querySelector('.card-slider__btn--prev');
    this.btnNext = this.querySelector('.card-slider__btn--next');

    if (this.btnPrev && this.btnNext && this.scroller) {
      this.btnPrev.addEventListener('click', this.scrollPrev.bind(this));
      this.btnNext.addEventListener('click', this.scrollNext.bind(this));
      this.scroller.addEventListener('scroll', this.updateButtons.bind(this));

      // Initial state
      setTimeout(() => this.updateButtons(), 100);
    }
  }

  scrollPrev(e) {
    e.preventDefault();
    e.stopPropagation();
    this.scroller.scrollBy({ left: -this.scroller.clientWidth, behavior: 'smooth' });
  }

  scrollNext(e) {
    e.preventDefault();
    e.stopPropagation();
    this.scroller.scrollBy({ left: this.scroller.clientWidth, behavior: 'smooth' });
  }

  updateButtons() {
    if (this.scroller.scrollLeft <= 0) {
      this.btnPrev.setAttribute('disabled', 'true');
      this.btnPrev.classList.add('card-slider__btn--hidden');
    } else {
      this.btnPrev.removeAttribute('disabled');
      this.btnPrev.classList.remove('card-slider__btn--hidden');
    }

    if (this.scroller.scrollLeft >= this.scroller.scrollWidth - this.scroller.clientWidth - 1) {
      this.btnNext.setAttribute('disabled', 'true');
      this.btnNext.classList.add('card-slider__btn--hidden');
    } else {
      this.btnNext.removeAttribute('disabled');
      this.btnNext.classList.remove('card-slider__btn--hidden');
    }
  }
}

if (!customElements.get('card-slider')) {
  customElements.define('card-slider', CardSlider);
}
